import { createSlice } from "@reduxjs/toolkit";

export const UserDataSlice = createSlice({
  name: "logindata",
  initialState: {
    auth: {},
    accessToken: '',
    userId: '',
    profileData: {},
    userAuthId: '',
    loggedIn: '',
    createGameData: {},
    unseenData: '',
    currentLocation: {},
    profileLocation: { address: '', latitude: '', longitude: '' },
    saveCardDetailData: {},
    subscriptionPlanData: {},
    configurationData: {},
    paymentIntentId: '',
    storeNotificationData: [],
    transactionId: '',
    gameCreatePayload: '',
    paymentWay: '',
    gameIdForRequestToJoin: '',
    profilefilterUpdate: false,
    selectedLocation: '',
    courtData: [],
    setParticipantsUser: {},
    sportDetailConfig: [],
    saveFetchMinorPermission: {},
    fetchMinorPermission: {},
    minorAccountList: [],
    filterUpdating: false,
    filterGameUpdating: false,
    inviteSelectedPlayers: [],
    isOnBoarded: false,
    privacyPolicyData: {},
    termAndConditionData: {}
  },

  reducers: {
    saveAuthData: (state, action) => {
      state.auth = action.payload;
    },
    saveToken: (state, action) => {
      state.accessToken = action.payload;
    },
    saveUserId: (state, action) => {
      state.userId = action.payload;
    },

    saveUserData: (state, action) => {
      state.userInfo = action.payload;
    },

    saveProfileData: (state, action) => {
      state.profileData = action.payload
    },

    saveUserAuthId: (state, action) => {
      state.userAuthId = action.payload
    },
    saveLoggedIn: (state, action) => {
      state.loggedIn = action.payload
    },
    saveCreateGameData: (state, action) => {
      state.createGameData = action.payload
    },
    saveUnseenData: (state, action) => {
      state.unseenData = action.payload
    },
    saveCurrentLocation: (state, action) => {
      state.currentLocation = action.payload
    },
    saveProfileLocation: (state, action) => {
      state.profileLocation = action.payload
    },
    saveCardDetail: (state, action) => {
      state.saveCardDetailData = action.payload
    },
    saveSubscriptionPlan: (state, action) => {
      state.subscriptionPlanData = action.payload
    },
    saveConfiguration: (state, action) => {
      state.configurationData = action.payload
    },
    savePaymentIntentId: (state, action) => {
      state.paymentIntentId = action.payload
    },
    saveNotificationData: (state, action) => {
      state.storeNotificationData = action.payload
    },
    saveTransactionId: (state, action) => {
      state.transactionId = action.payload
    },
    saveGameCreatePayload: (state, action) => {
      state.gameCreatePayload = action.payload
    },
    savePaymentWay: (state, action) => {
      state.paymentWay = action.payload
    },
    saveGameIdForRequestToJoin: (state, action) => {
      state.gameIdForRequestToJoin = action.payload
    },
    saveProfileFilterUpdate: (state, action) => {
      state.profilefilterUpdate = action.payload;
    },
    saveSelectedLocations: (state, action) => {
      state.selectedLocation = action.payload;
    },
    saveCourtData: (state, action) => {
      state.courtData = action.payload
    },
    saveParticipantsUser: (state, action) => {
      state.setParticipantsUser = action.payload
    },
    saveSportDetailConfig: (state, action) => {
      state.sportDetailConfig = action.payload
    },
    saveFetchMinorPermission: (state, action) => {
      state.fetchMinorPermission = action.payload
    },
    saveMinorAccountList: (state, action) => {
      state.minorAccountList = action.payload
    },
    saveFilterUpdating: (state, action) => {
      state.filterUpdating = action.payload
    },
    saveGameFilterUpdating: (state, action) => {
      state.filterGameUpdating = action.payload
    },
    saveFilterGameUpdating: (state, action) => {
      state.filterGameUpdating = action.payload
    },
    saveInviteSelectedPlayer: (state, action) => {
      state.inviteSelectedPlayers = action.payload
    },
    saveIsOnBoarded: (state, action) => {
      state.isOnBoarded = action.payload
    },
    savePrivacyPolicy: (state, action) => {
      state.privacyPolicyData = action.payload
    },
    saveTermAndCondition: (state, action) => {
      state.termAndConditionData = action.payload
    }

  },
});
export const { saveAuthData, saveUserData, saveToken, saveUserId, saveProfileData, saveUserAuthId, saveLoggedIn, saveCreateGameData, saveProfileDetail, saveUnseenData, saveCurrentLocation, saveProfileLocation, saveCardDetail, saveSubscriptionPlan, saveConfiguration, savePaymentIntentId, saveNotificationData, saveTransactionId, saveGameCreatePayload, savePaymentWay, saveGameIdForRequestToJoin, saveProfileFilterUpdate, saveSelectedLocations, saveCourtData, saveParticipantsUser, saveSportDetailConfig, saveFetchMinorPermission, saveMinorAccountList, saveFilterUpdating, saveFilterGameUpdating, saveInviteSelectedPlayer, saveIsOnBoarded, savePrivacyPolicy, termAndConditionData,saveTermAndCondition } = UserDataSlice.actions;
export default UserDataSlice.reducer;
